import React, { useState } from 'react'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import Header from './Header'
import Sidebar from './Sidebar'

const Layout = ({ children }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile)

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const handleSidebarClose = () => {
    setSidebarOpen(false)
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Header 
        onSidebarToggle={handleSidebarToggle}
        sidebarOpen={sidebarOpen}
      />
      
      <Sidebar 
        open={sidebarOpen}
        onClose={handleSidebarClose}
        isMobile={isMobile}
      />
      
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: '64px',
          minHeight: '100vh',
          bgcolor: 'background.default',
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <Box sx={{ 
          p: { xs: 1, sm: 1.5, md: 2 },
          ml: 0,
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box'
        }}>
          {children}
        </Box>
      </Box>
    </Box>
  )
}

export default Layout